export const site = {
  name: "PlayMath.org",
  baseUrl: "https://playmath.org",
  defaultTitle: "PlayMath.org - Level up your kids with math games",
  defaultDescription:
    "Supercharge your kids' brains with fun math games. Loved by teachers & parents.",
};

export function absoluteUrl(path: string): string {
  if (!path) return site.baseUrl;
  try {
    return new URL(path, site.baseUrl).toString();
  } catch {
    return `${site.baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
  }
}

export const ids = {
  website: `${site.baseUrl}#website`,
  organization: `${site.baseUrl}#organization`,
  about: {
    webpage: `${site.baseUrl}/about#webpage`,
    breadcrumb: `${site.baseUrl}/about#breadcrumb`,
    faq: `${site.baseUrl}/about#faq`,
    article: `${site.baseUrl}/about#article`,
    serviceArea: `${site.baseUrl}#service-area`,
    educationalService: `${site.baseUrl}#educational-service`,
    gamingPlatform: `${site.baseUrl}#gaming-platform`,
    educationalOrg: `${site.baseUrl}#educational-org`,
  },
  blog: {
    webpage: `${site.baseUrl}/blog#webpage`,
    breadcrumb: `${site.baseUrl}/blog#breadcrumb`,
  },
};
